import {TemplateModelV1} from 'resources/GeneratedModels/Template/TemplateModel.v1';
import sessionStore from 'client/Session/SessionStore';
import {Map} from 'immutable';
import {addToast} from '@albert-io/atomic';
import {invalidatePartialInterest} from 'resources/mandark.resource';
import {resource} from '@albert-io/json-api-framework/request/builder';

export const convertToFolder = async (folderName, questionSets) => {
  const questionSetCustomMeta = questionSets.reduce((acc, questionSet, index) => {
    if (questionSet) {
      // @ts-ignore - acc type
      return acc.set(questionSet.getId(), {position: index});
    }
    return acc;
  }, Map());

  const newFolder = new TemplateModelV1()
    .setName(folderName)
    .setCorrectAnswerSetting('template')
    .setMessage('template')
    .addRelationship({
      type: 'teacher_v1',
      relation: sessionStore.getUserId()
    })
    .updateRelationship('question_sets_v1', questionSets, true, questionSetCustomMeta);

  try {
    const [createdFolder] = await Promise.all([
      newFolder.save(),
      new Promise((resolve) => setTimeout(resolve, 3000))
    ]);
    invalidateTemplatesRequests();
    addToast({
      type: 'success',
      title: 'Success',
      message: 'Folder sucessfully created'
    });
    return createdFolder;
  } catch (err) {
    addToast({
      type: 'danger',
      title: 'Something went wrong',
      message: 'We were unable to save your questions to a folder'
    });
    return null;
  }
};

function invalidateTemplatesRequests() {
  invalidatePartialInterest(resource('templates_v1').mandarkEndpoint(['templates_v1']).done());
  invalidatePartialInterest(resource('assignments_v2').mandarkEndpoint(['assignments_v2']).done());
}
